import StepHeader from '../StepHeader';
import { useFormStepTranslation } from './useFormStepTranslation';

export const TransportSelectionContext = () => {
	const { t } = useFormStepTranslation();

	const title = t('online-banking');
	const subtitle = t('choose-bank-account-login-message');
	return <StepHeader title={title} subtitle={subtitle} />;
};
